import {
  correctImageBreakpoints2023,
  type ImageBreakpointKeys,
} from '../../config/breakpoints';
import type { ViewportsSizes } from './SemboImage.types';

// Construct the sizes string by mapping through the breakpoints
// and fallback to 100vw if a specific size is not provided in sizeElements
export const getImageSizes = (
  sizeKeys: ImageBreakpointKeys[],
  filledSizes: Partial<ViewportsSizes>
) =>
  sizeKeys
    .map((key, index) => {
      const width = filledSizes[key as keyof ViewportsSizes];
      const viewportWidth =
        correctImageBreakpoints2023[
          key as keyof typeof correctImageBreakpoints2023
        ];

      if (index === sizeKeys.length - 1) {
        return `(max-width: ${viewportWidth}px) ${width}, (min-width: ${viewportWidth}px) ${width}`;
      }
      return `(max-width: ${viewportWidth}px) ${width}`;
    })
    .join(', ');
